module.exports = __webpack_public_path__ + "img/img_Colleges19.f43e6e9d.jpg";